import {encodeParams} from 'shared/utilities'
import _ from 'lodash'

const testEnv = process.env.NODE_ENV === 'test'
const baseUrl = `${testEnv ? 'http://localhost' : ''}`

const baseConfig = {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
    }
}

const api = async (url, options = {}, config = {}, open_access = false, upload = false) => {
    const mergedConfig = {...baseConfig, ...config}

    if (upload) {
        mergedConfig.headers = _.omit(mergedConfig.headers, "Content-Type")
    }
    const queryString = encodeParams(options);
    const requestUrl = queryString ? `${baseUrl}${url}?${queryString}` : `${baseUrl}${url}`;


    return fetch(requestUrl, mergedConfig).then(checkStatus)
}

const checkStatus = (response) => {
    // raises an error in case response status is not a success
    if ((response.status >= 200 && response.status < 300) || response.status === 422) {
        return response
    } else {
        const error = new Error(response.statusText)
        error.response = response
        throw error
    }
}

export const handleAPIErrors = (exception, cb) => {
    if (exception.hasOwnProperty('errors')) {
        cb(exception.errors)
    } else if (exception.response !== undefined) {
        if (exception.response.status) {
            if (exception.response.status == 451) {
                toastr.error('Session expired.')
                setTimeout(() => {
                    window.location = '/'
                }, 1000)
            } else{
                cb({base: ['Not Authorized']})
            }
        } else {
            cb({base: ['Response not handled. Please try again later.']})
        }
    } else {
        cb({base: ['Error response unknown. Please try again later.']})
    }
}

export default api
